import { useEffect, useRef } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

/**
 * Il frammento in `public/index.html` invia il primo PageView al load.
 * Sulle navigazioni client-side serve un PageView aggiuntivo (SPA).
 */
export function MetaPixelRouteTracker() {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname, location.search]);

  return <Outlet />;
}
